import RiskSymbolsLegends from './RiskSymbolsLegends';

/**
 * RiskLegendCard — shared styled card wrapping the risk symbols legend.
 * Used in both the active substance and commercial product detail pages
 * to ensure consistent presentation.
 *
 * @param {Object} props
 * @param {string} [props.title] - Optional custom link text for the risk symbols link
 * @param {boolean} [props.bordered=true] - Whether to show the card border/background
 * @param {string} [props.className] - Additional className for the outer wrapper
 */
const RiskLegendCard = ({ title, bordered = true, className = '' }) => {
  const cardClasses = bordered
    ? 'rounded-2xl bg-gray-50 border border-gray-200 px-6 py-4'
    : '';

  return (
    <div className={`flex justify-end ${className}`}>
      <div className={cardClasses}>
        <RiskSymbolsLegends title={title} />
      </div>
    </div>
  );
};

export default RiskLegendCard;
